import React, { useContext, useMemo } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';

export function AvatarName({
  mode = 'hd',
  avatar,
  hideName,
  style
}) {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };


  const drawCross = (cross) => {
    // return cross.length ? `${findHexagram(cross[0])}${findHexagram(cross[1])}${findHexagram(cross[2])}${findHexagram(cross[3])}` : '䷀䷀䷀䷀';
  }


  const obscureName = (cross = []) => {

    let a = drawCross(cross);
    // a = a.substring(0, title.length);
    return a

  }



  const $ui = context.$ui;

  const displayName = useMemo(() => {
    if (!avatar) return null;
    if (context.state.hideNames || hideName) {
      return context.getDefaultTitle(avatar.design, 'type');
    }
    return avatar.name ? avatar.name : context.getDefaultTitle(avatar.design);
  }, [avatar, avatar?.design, avatar?.name, hideName, context.state.hideNames, context.getDefaultTitle]);

  return (
    <>
      {displayName}
    </>
  )
}